<template>
  <div class="ren-decoration-cp ren-decoration-cp-action-card">
    <i :style="iconStyle">{{ iconText }}</i>
    <div>
      <strong>{{ title }}</strong>
      <span v-if="subtitle">{{ subtitle }}</span>
    </div>
    <button v-if="buttonText" type="button" :style="buttonStyle">{{ buttonText }}</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../previews/preview-helpers'
import type { WidgetPreviewProps } from './types'

const props = defineProps<
  WidgetPreviewProps & {
    icon?: string
  }
>()

const title = computed(() => stringValue(props.component.props?.title, props.component.title || ''))
const subtitle = computed(() => stringValue(props.component.props?.subtitle ?? props.component.props?.content))
const buttonText = computed(() => stringValue(props.component.props?.buttonText))
const iconText = computed(() => {
  const value = stringValue(props.icon || props.component.props?.icon || props.component.props?.badgeText).trim()
  if (value) return value.slice(0, 1)
  return title.value.slice(0, 1) || '·'
})
const iconStyle = computed(() => ({
  backgroundColor:
    stringValue(props.component.style?.badgeColor) ||
    props.themeTokens?.primaryColor ||
    props.themeColor ||
    'var(--ren-theme-primary)'
}))
const buttonStyle = computed(() => ({
  backgroundColor: props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)',
  color: '#fff'
}))
</script>

<style scoped>
.ren-decoration-cp-action-card {
  background: transparent;
}
</style>
